module.exports = __webpack_public_path__ + "static/media/close.110112d1.svg";